import VueEcho from 'vue-echo';
import Vue from 'vue';
import Pusher from 'pusher-js';
import VueNativeNotification from 'vue-native-notification';

Vue.use(VueNativeNotification, {
  // Automatic permission request before
  // showing notification (default: true)
  requestOnNotify: true,
});

window.Pusher = Pusher;
const token = localStorage.getItem('token') || 'false';

var config = {
  broadcaster: 'pusher',
  key: process.env.VUE_APP_PUSHER_APP_KEY,
  cluster: process.env.VUE_APP_PUSHER_APP_CLUSTER,
  authEndpoint: process.env.VUE_APP_LARAVEL_API_URL + '/broadcasting/auth',
  auth: {
    headers: {
      Authorization: 'Bearer' + token,
    },
  },
  encrypted: false,
  forceTLS: false,
  enabledTransports: ['ws', 'wss'],
  namespace: 'App\\Events',
  // disableStats: true,
};

// use webockets url or host+port config
if (process.env.VUE_APP_WEBSOCKETS_URL) {
  config.wsHost = process.env.VUE_APP_WEBSOCKETS_URL;
  config.wsPort = 80;
  config.wssPort = 443;
} else {
  //defaults:
  config.wsHost = 'localhost';
  if (process.env.VUE_APP_WEBSOCKETS_HOST) config.wsHost = process.env.VUE_APP_WEBSOCKETS_HOST;
  if (process.env.VUE_APP_WEBSOCKETS_PORT) config.wsPort = process.env.VUE_APP_WEBSOCKETS_PORT;
}

if (process.env.VUE_APP_WEBSOCKETS_ENABLE) {
  Vue.use(VueEcho, config);
}
